<template>
  <div v-if="cropInfo.ifCropShow">
    <div class="title">
      <b-row align-h="between">
        <b-col cols="10">
          <h6 class="mb-0">農情作物</h6>
        </b-col>
      </b-row>
    </div>
    <div class="p-3" v-show="cropInfo.ifCropShow">
      {{ cropInfo.cropName || "" }}<br />
      {{ cropInfo.year || "" }}．{{ cropInfo.period || "" }}
      <hr />
      <p>
        {{ cropInfo.townName || "未選取" }}
      </p>
      <p>
        {{ cropInfo.sectorName || "" }}
      </p>
      <b-table-simple v-if="showdetail" hover small striped responsive>
        <b-tbody>
          <b-tr>
            <b-td>現況面積</b-td>
            <b-td>{{ cropInfo.area_situation || "0" }} 公頃</b-td>
          </b-tr>
          <b-tr>
            <b-td>種植面積</b-td>
            <b-td>{{ cropInfo.area_P || "0" }} 公頃</b-td>
          </b-tr>
          <b-tr>
            <b-td>間作面積</b-td>
            <b-td>{{ cropInfo.area_I || "0" }} 公頃</b-td>
          </b-tr>
          <b-tr>
            <b-td>前後期作面積</b-td>
            <b-td>{{ cropInfo.area_O || "0" }} 公頃</b-td>
          </b-tr>
          <b-tr>
            <b-td>未達結實面積</b-td>
            <b-td>{{ cropInfo.area_NH || "0" }} 公頃</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <h6 class="memo-h4">※現況面積計算公式為種植面積加上間作面積及前後期作面積(不包含未達結實面積)</h6>
    </div>
  </div>
</template>

<script>
// import VueDragResize from "vue-drag-resize";

export default {
  name: "DragCropInformationBox",
  data() {
    return {
      // <summary>
      //  變數宣告
      // </summary>
      cropshow: false,
      datetime: [],
      mergetime: "",
      codition: "",
      alertinformation: "",
      title: "",
      message: "",
      showdetail: true,
      disasterTile: [
        "",
        "颱風警戒",
        "焚風警戒",
        "降水警戒",
        "高溫警戒",
        "寒害警戒",
        "注意霪雨",
        "注意高溫",
        "注意寒害",
        "注意回溫",
        "注意降溫",
      ],
      yearSelected: "",
      periodSelected: "",
      resize: true,
      // infoheight: 600
    };
  },
  props: ["cropInfo"],
  // components: {
  //   VueDragResize,
  // },
  mounted() {
    // this.init()
    // this.checkPermission()
  },
  methods: {
    /*       <summary>
          關閉歷年作物查詢的視窗
         </summary>*/
    closeCropInfo() {
      this.$parent.closeCropInfo();
    },
    /*       <summary>
          關閉價量預警資料視窗
         </summary>*/
    closeTradeWarning() {
      this.$parent.closeTradeWarning();
    },
    async checkPermission() {
      let data = { PJ_ID: "PJ000000000003", fun: this.checkByPJID };
      this.FunctionToken(this.Authority, data);
    },
    checkByPJID(value) {
      if (!value) {
        this.showdetail = false;
      } else {
        this.showdetail = true;
      }
    },
    transDate(date) {
      let datearray = date.split("T")[0].split("-");
      let value = datearray[1] + "/" + datearray[2] + "日";
      return value;
    },
  },
};
</script>

<style>
.gis-info {
  height: auto;
  display: inline-block !important;
}
.p-3 {
  position: relative;
}
.memo-h4{
  color: blue;
}
</style>
